export default {
  "languages": {
    "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
    "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italiano"])}
  },
  "labels": {
    "kpis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KPIs"])},
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["search"])},
    "definition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definition"])},
    "formula": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formula"])},
    "dashboard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])},
    "summary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Summary"])},
    "page-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KPIs"])},
    "modify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modify"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
  },
  "strings": {
    "delete-kpi-question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete this KPI?"])},
    "kpi-deleted": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KPI deleted"])}
  },
  "errors": {
    
  }
}